<template>
    <div>
        <template v-for="cash in cashes">
            <noti-item v-bind="{ cash }" :key="cash._id" />
        </template>
    </div>
</template>

<script>
import api from "@/api";
import dayjs from "@/plugins/vue-dayjs";

import NotiItem from "./noti/noti-item.vue";

export default {
    components: {
        NotiItem,
    },
    props: {
        shows: { type: Boolean, default: false },
    },
    data: () => ({
        cashes: [],
        showing: {},
        intervalId: undefined,
        intervalTimeout: 1000 * 1,
    }),
    methods: {
        init() {
            this.intervalId = setInterval(this.exec, this.intervalTimeout);
        },
        undo() {
            if (this.intervalId) clearInterval(this.intervalId);
        },
        async exec() {
            let date = dayjs()
                .subtract(this.intervalTimeout * 1.1, "millisecond")
                .toISOString();

            let { cashes } = await api.v1.me.cashes.gets({
                params: {
                    type: "리워드",
                    createdAt: JSON.stringify({ $gte: date }),
                },
            });

            this.cashes = this.cashes.concat(...cashes.filter(({ _id }) => !this.cashes.some((item) => item._id == _id)));
        },
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
            else this.undo();
        },
    },
};
</script>

<style></style>
